// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

/**
 * Compact banner shown when an external integration connection needs
 * re-auth (refresh path caught invalid_grant upstream). Shared by the
 * dashboard Calendar panel, the client Meetings tab and the relationship
 * Emails card.
 *
 * Extracted from TodaysMeetingsWidget when that widget was replaced by
 * DashboardCalendarPanel.
 */

import { AppIcon } from '@loa/ui-components';
import './IntegrationReauthBanner.css';

export function IntegrationReauthBanner({ provider }: Readonly<{ provider: string }>) {
  return (
    <div className="integration-reauth-banner" role="alert">
      <AppIcon name="warning sign" />
      <div>
        <p>
          Your {provider === 'GOOGLE' ? 'Google' : 'Microsoft'} connection needs to be refreshed.
        </p>
        <p>
          <a href="/logout">Sign in again</a> to reconnect your calendar.
        </p>
      </div>
    </div>
  );
}
